import { __assign } from "tslib";
import React from 'react';
import { withErrorBoundary } from '../../ErrorBoundary/withErrorBoundary';
import { DeviationTypes } from '../../types/deviation';
import { getDeviationType } from '../_helpers';
import JournalFeedCard from './Journal';
import StatusFeedCard from './Status';
import PollFeedCard from './Poll';
import TierFeedCard from './Tier';
import CommissionFeedCard from './Commission';
var FeedCard = function (props) {
    switch (getDeviationType(props.deviation)) {
        case DeviationTypes.COMMISSION:
            return React.createElement(CommissionFeedCard, __assign({}, props));
        case DeviationTypes.POLL:
            return React.createElement(PollFeedCard, __assign({}, props));
        case DeviationTypes.JOURNAL:
            return React.createElement(JournalFeedCard, __assign({}, props));
        case DeviationTypes.STATUS:
            return React.createElement(StatusFeedCard, __assign({}, props));
        case DeviationTypes.TIER:
            return React.createElement(TierFeedCard, __assign({}, props));
        default:
            return null;
    }
};
FeedCard.displayName = 'FeedCard';
export default withErrorBoundary(FeedCard, 'FeedCard');
//# sourceMappingURL=Feed.js.map